import { createCrudApi } from './crud.api';
import { BankAlias } from '../types';

export const bankAliasesApi = createCrudApi<BankAlias>('/bank-aliases');
